import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer";

import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
// const store = configureStore({
//   reducer: rootReducer,
// });

// export default store;

const persistConfig = {
  key: "root",
  storage,
  // whitelist: ["Rolesandpermission_data"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistedStore = persistStore(store);

const { dispatch } = store;

export { store, dispatch, persistedStore };
